import React from "react";
import {
  I2cSelect,
  I2cMenuItem,
  I2cDatePicker,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "./FiltersDrawerContent.scss";
import { formatDate } from "../Users/FiltersDrawerContent";
import { getFormattedDate } from "../../Utils/stringUtls";
export const FiltersDrawerContent = ({
  onClose = () => { },
  handleConfirmation = () => { },
  defaultValues = {
    status: "",
    type: "",
    from: "",
    to: "",
  },
}) => {
  const [filterDataInternal, setFilterDataInternal] =
    React.useState(defaultValues);
  const isImplementationQueue = window.location.pathname.includes("sales");
  return (
    <div>
      <div className="sales-filters-container">
        <div className="filters-header-description">
          Apply filtrs for page content.
        </div>
        <I2cSelect
          className="request-status-select"
          onI2cChange={(e) => {
            setFilterDataInternal({
              ...filterDataInternal,
              status: e.target.value ?? "",
            });
          }}
          value={filterDataInternal?.status}
          label="Request Status"
          placeholder="Form Status"
          size="large"
        >
          {isImplementationQueue ? (
            <>
              <I2cMenuItem value="1">Draft</I2cMenuItem>
              <I2cMenuItem value="2">New Requests</I2cMenuItem>
            </>
          ) : (
            <>
              <I2cMenuItem value="3">New</I2cMenuItem>
              <I2cMenuItem value="4">Signed Off</I2cMenuItem>
              <I2cMenuItem value="5">Completed</I2cMenuItem>
              <I2cMenuItem value="7">Pending Stakeholder Sign-off</I2cMenuItem>
              <I2cMenuItem value="8">Stakeholder Approved</I2cMenuItem>
            </>
          )}
        </I2cSelect>

        <I2cSelect
          className="request-status-select"
          onI2cChange={(e) => {
            setFilterDataInternal({
              ...filterDataInternal,
              type: e.target.value,
            });
          }}
          value={filterDataInternal?.type}
          label="Program Type"
          placeholder="Prepaid/Debit"
          size="large"
        >
          <I2cMenuItem value="1">Prepaid/Debit</I2cMenuItem>
          <I2cMenuItem value="2">Credit</I2cMenuItem>
        </I2cSelect>
        <div
          style={{
            display: "flex",
            gap: "var(--i2c-spacing-4)",
            flexWrap: "wrap",
            marginBottom: "var(--i2c-spacing-6)",
          }}
        >
          <I2cDatePicker
            dateFormat="F d, Y"
            label="Filter By Date"
            suffix='<i2c-icon name="linear-calendar-2" slot="suffix" class="suffix-iCon4"></i2c-icon>'
            hoist
            rotateIcon
            errorMessageInvisible={true}
            size="large"
            allowInput={false}
            // [new Date(filterDataInternal.from), new Date(filterDataInternal.to)]
            defaultDate={[
              formatDate(filterDataInternal.from),
              formatDate(filterDataInternal.to),
            ]}
            onI2cDateApply={(e) => {
              const from = getFormattedDate(
                e.target.appliedDate[0]?.toDateString(),
              );
              const to = getFormattedDate(
                e.target.appliedDate[1]?.toDateString(),
              );
              setFilterDataInternal({
                ...filterDataInternal,
                from: from ?? "",
                to: to ?? "",
              });
            }}
            screen="mobile"
          ></I2cDatePicker>
        </div>

        <div className="filter-drawer-footer">
          <I2cButton
            slot="footer"
            variant="secondary gray"
            onClick={() => {
              setFilterDataInternal({
                status: "",
                type: "",
                from: "",
                to: "",
              });
              handleConfirmation({
                status: "",
                type: "",
                from: "",
                to: "",
              });
            }}
            disabled={false}
            className="btn"
            size={"medium"}
          >
            Cancel
          </I2cButton>
          <I2cButton
            onClick={() => handleConfirmation(filterDataInternal)}
            slot="footer"
            variant={"primary"}
            disabled={false}
            className="btn"
            size={"medium"}
          >
            Confirm
          </I2cButton>
        </div>
      </div>
    </div>
  );
};
